<template>
	<div class="container">
		<div class="row">
			<div class="col-lg-4 offset-lg-4">
				<div class="card card-body mt-5p border-0">
					<div class="text-center" v-if="isSubmitting">
						<img :src="appLogo" width="200px" class="d-block m-auto" :alt="appName">
						<div class="spinner-border my-4" style="width: 3rem; height: 3rem;" role="status">
							<span class="sr-only">Loading...</span>
						</div>
						<div>
							Sedang memuat...<br> Mohon untuk tidak menutup halaman ini!
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import Axios from 'axios';
import router from '@/router';
import { getOS, getDeviceType, getBrowser, duplicateVar } from '@/lib/helper';

export default {
	name: 'AuthCallback',
	data() {
		return {
			isSubmitting: true,
			ip: null,
			latitude: null,
			longitude: null,
			position: null,
			isLocating: false,
		};
	},
	methods: {
		getIp() {
			const endpoint = 'https://public.orderonline.id/ip';
			Axios.get(endpoint)
				.then((response) => {
					const ip = response.data.ip;
					this.ip = ip;
				})
				.catch(() => {
					this.isLocationFetched = true;
				});
		},
		getLocation() {
			this.isLocating = true;
			if (navigator.geolocation) {
				const onSuccess = (pos) => {
					this.position = duplicateVar(pos);
					const lat = pos.coords.latitude;
					const long = pos.coords.longitude;
					this.latitude = lat;
					this.longitude = long;
					this.isLocating = false;
					// console.log(pos);
				};
				const onError = () => {
					this.isLocating = false;
				};
				navigator.geolocation.getCurrentPosition(onSuccess, onError);
			} else {
				this.isLocating = false;
			}
		},
		connect() {
			this.isSubmitting = true;

			const userId = this.$route.query.oo_user;
			const token = this.$route.query.token;
			const ref = this.$route.query.ref;

			const metaJson = JSON.stringify(this.meta);
			const creds = {
				oo_user_id: userId,
				oo_token: token,
				meta: metaJson,
			};

			if (ref) {
				creds.ref = ref;
			}

			const payload = {
				creds,
			};
			if (this.referrer && this.referrer !== '') {
				payload.redirectPath = this.referrer;
			}
			this.$store.dispatch('loginWithOO', payload);
		},
	},
	computed: {
		...mapGetters({
			appLogo: 'appLogo',
			appName: 'appName',
			loginError: 'loginError',
		}),
		meta() {
			const os = getOS();
			const deviceType = getDeviceType();
			const browser = getBrowser();
			const location = this.location;
			const userAgent = window.navigator.userAgent;
			const meta = {
				ip: this.ip,
				os,
				device: deviceType,
				browser,
				location,
				lat: this.latitude,
				long: this.longitude,
				user_agent: userAgent,
			};
			return meta;
		},
	},
	created() {
		this.getIp();
		this.getLocation();
		this.connect();
	},
	watch: {
		loginError() {
			if (this.loginError) {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: this.loginError,
				});

				router.push('/login');
			}
		},
	},
};
</script>
<style scoped>
.mt-5p {
	margin-top: 5em;
}
</style>
